import { createRestError } from "../../utils/RestError";

const organisationDetailErrorHandler = (e: any): string | undefined => {
  if (e === undefined || !e.isAxiosError) {
    return undefined;
  }

  const restError = createRestError(e);
  if (restError.statusCode === 404) {
    return "error.organisationDetail404";
  } else {
    return undefined;
  }
};

export default organisationDetailErrorHandler;
